import React from 'react';
import { styled } from '@nykaa/nes-ui-components';
import loadable from '@loadable/component';
import AnimatedLoader from 'components/BelowTheFoldControl/AnimatedLoader';

const Loading = styled(AnimatedLoader)`
  height: 500px;
`;

export default loadable(() => import(/* webpackChunkName: "offline" */ './View'), {
  fallback: <Loading />,
});
